import { AddressDetails } from "../smart-components/smart-component-property";
import { SmartComponentPropertyDetails } from "../smart-components/smart-component-property-details";
import { SkillNameList } from "../../enum/enumSkillNameList";
import { IComponentLoader } from "../../interfaces/IComponentLoader";
import { ComponentAdapterParent } from "./component-adapter-parent";


/**
 * This class handle properties of light
 */
export class ComponentAdapterSensor extends ComponentAdapterParent implements IComponentLoader {
    private _presence: AddressDetails = null;
    private _ambientBrightness: AddressDetails = null;
    private _ambientBrightnessSetpoint: AddressDetails = null;
    private _ambientBrightnessSetpointMin: string = "";
    private _ambientBrightnessSetpointMax: string = "";
    private _stateAutoManBrightness: AddressDetails = null;
    private _commandAutoManBrightness: AddressDetails = null;
    private _faultState: AddressDetails = null;
    private _dimmerOnOffCommand: AddressDetails = null;
    private _dimmerOnOffState: AddressDetails = null;
    private _dimmerCommand: AddressDetails = null;
    private _dimmerName: string = "";
    private _dimmerState: AddressDetails = null;
    private _currentColorTemperature: AddressDetails = null;
    private _setpointColorTemperature: AddressDetails = null;
    private _setpointColorTemperatureMin: string = "";
    private _setpointColorTemperatureMax: string = "";
    private _colorTemperatureAutoMan: AddressDetails = null;
    private _colorTemperatureState: AddressDetails = null;

    constructor() {
        super();
    }

    /**
     * Get presence address
     */
    get Presence(): AddressDetails {
        return this._presence;
    }

    /**
     * Get ambient brightness address
     */
    get AmbientBrightness(): AddressDetails {
        return this._ambientBrightness;
    }

    /**
     * Get ambient brightness setpoint address
     */
    get AmbientBrightnessSetpoint(): AddressDetails {
        return this._ambientBrightnessSetpoint;
    }

    /**
     * Get ambient brightness setpoint min
     */
    get AmbientBrightnessSetpointMin(): string {
        return this._ambientBrightnessSetpointMin;
    }

    /**
     * Get ambient brightness setpoint max
     */
    get AmbientBrightnessSetpointMax(): string {
        return this._ambientBrightnessSetpointMax;
    }

    /**
     * Get automatic manual state address
     */
    get StateAutomanBrightness(): AddressDetails {
        return this._stateAutoManBrightness;
    }

    /**
     * Get automatic manual command address
     */
    get CommandAutomanBrightness(): AddressDetails {
        return this._commandAutoManBrightness;
    }

    /**
      * Get fault state address
      */
    get FaultState(): AddressDetails {
        return this._faultState;
    }

    /**
     * Get dimmer on-off command address
     */
    get DimmerOnOffCommand(): AddressDetails {
        return this._dimmerOnOffCommand;
    }

    /**
     * Get dimmer on-off state address
     */
    get DimmerOnOffState(): AddressDetails {
        return this._dimmerOnOffState;
    }

    /**
     * Get dimmer command address
     */
    get DimmerCommand(): AddressDetails {
        return this._dimmerCommand;
    }

    /**
     * Get dimmer state address
     */
    get DimmerState(): AddressDetails {
        return this._dimmerState;
    }

    /**
     * Get dimmer name
     */
    get DimmerName(): string {
        return this._dimmerName;
    }

    /**
     * Get current color temperature address
     */
    get CurrentColorTemperature(): AddressDetails {
        return this._currentColorTemperature;
    }

    /**
    * Get setpoint color temperature address
    */
    get SetpointColorTemperature(): AddressDetails {
        return this._setpointColorTemperature;
    }

    /**
     * Get setpoint color temperature min
     */
    get SetpointColorTemperatureMin(): string {
        return this._setpointColorTemperatureMin;
    }

    /**
     * Get setpoint color temperature max
     */
    get SetpointColorTemperatureMax(): string {
        return this._setpointColorTemperatureMax;
    }

    /**
    * Get color temperature automan address
    */
    get ColorTemperatureAutoman(): AddressDetails {
        return this._colorTemperatureAutoMan;
    }

    /**
    * Get color temperature address
    */
    get ColorTemperatureState(): AddressDetails {
        return this._colorTemperatureState;
    }

    public fillProperty(listSmartComponentSkills: Array<SmartComponentPropertyDetails>): void {
        this._name = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.SENSOR_NAME)?.value || "";
        this._description = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_DESCRIPTION)?.value || "";

        this._presence = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_PRESENCE)?.address || null;
        this._ambientBrightness = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_AMBIENT_BRIGHTNESS)?.address || null;
        this._ambientBrightnessSetpoint = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_AMBIENT_BRIGHTNESS_SETPOINT)?.address || null;
        this._ambientBrightnessSetpointMin = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_AMBIENT_BRIGHTNESS_SETPOINT_MIN)?.value || "";
        this._ambientBrightnessSetpointMax = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_AMBIENT_BRIGHTNESS_SETPOINT_MAX)?.value || "";
        this._stateAutoManBrightness = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_STATE_AUTO_MAN)?.address || null;
        this._commandAutoManBrightness = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_COMMAND_AUTO_MAN)?.address || null;

        this._dimmerName = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.SENSOR_DIMMER_NAME)?.value || "";
        this._dimmerOnOffCommand = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_DIMMER_ON_OFF_COMMAND)?.address || null;
        this._dimmerOnOffState = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_DIMMER_ON_OFF_STATE)?.address || null;
        this._dimmerCommand = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_DIMMER_COMMAND)?.address || null;
        this._dimmerState = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_DIMMER_STATE)?.address || null;
        this._faultState = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_FAULT_STATE)?.address || null;

        this._currentColorTemperature = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_CURRENT_COLOR_TEMPERATURE)?.address || null;
        this._setpointColorTemperature = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_SETPOINT_COLOR_TEMPERATURE)?.address || null;
        this._setpointColorTemperatureMin = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_SETPOINT_COLOR_TEMPERATURE_MIN)?.value || "";
        this._setpointColorTemperatureMax = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_SETPOINT_COLOR_TEMPERATURE_MAX)?.value || "";
        this._colorTemperatureAutoMan = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_COLOR_TEMPERATURE_AUTOMAN)?.address || null;
        this._colorTemperatureState = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.SENSOR_STATE_COLOR_TEMPERATURE)?.address || null;

        this.fillMissingProperty();
        this.fillAddressState();
    }

    public fillMissingProperty(): void {
        if (this._dimmerOnOffState === null && this._dimmerOnOffCommand !== null) {
            this._dimmerOnOffState = this._dimmerOnOffCommand;
        }

        if (this._dimmerState === null && this._dimmerCommand !== null) {
            this._dimmerState = this._dimmerCommand;
        }

        if (this._stateAutoManBrightness === null && this._commandAutoManBrightness !== null) {
            this._stateAutoManBrightness = this._commandAutoManBrightness;
        }

        if (this._colorTemperatureState === null && this._colorTemperatureAutoMan !== null) {
            this._colorTemperatureState = this._colorTemperatureAutoMan;
        }
    }

    public fillAddressState(): void {
        if (this._presence) {
            this._listSubscribeAddress.push(this._presence);
        }

        if (this._ambientBrightness) {
            this._listSubscribeAddress.push(this._ambientBrightness);
        }

        if (this._ambientBrightnessSetpoint) {
            this._listSubscribeAddress.push(this._ambientBrightnessSetpoint);
        }

        if (this._faultState) {
            this._listSubscribeAddress.push(this._faultState);
        }

        if (this._stateAutoManBrightness) {
            this._listSubscribeAddress.push(this._stateAutoManBrightness);
        }

        if (this._dimmerOnOffState) {
            this._listSubscribeAddress.push(this._dimmerOnOffState);
        }

        if (this._dimmerState) {
            this._listSubscribeAddress.push(this._dimmerState);
        }

        if (this._colorTemperatureState) {
            this._listSubscribeAddress.push(this._colorTemperatureState);
        }

        if (this._currentColorTemperature) {
            this._listSubscribeAddress.push(this._currentColorTemperature);
        }

        if (this._setpointColorTemperature) {
            this._listSubscribeAddress.push(this._setpointColorTemperature);
        }
    }
}